export { ExclamationCircle as default } from './ExclamationCircle';
